import $ from 'jquery';
import '../../utility/csrf';
import AppStore from '../../stores/AppStore';
import { normalizeNumber } from '../../utility/formator';

export function guestPayment(params = {}) {
	$('.spinneroverlay').show()

	params.donationAmount = normalizeNumber(AppStore.getDonationAmount());
	params.currencyCode = AppStore.getDonationCode();
	params.currencySymbol = AppStore.getDonationSymbol();
	params.addressSharingConsent = AppStore.getShareAddress();
	params.note = AppStore.getDonationNote();
	params.recurring = AppStore.getDonationRecurring();

	return new Promise((resolve, reject) => {
		$.post('/donate/guest/onboarding', params, (result) => {
			return resolve(result);
		}).fail((err) => {
			return reject(err)
		}).always(() => {
			$('.spinneroverlay').hide();
		})
	})
};



// WEBPACK FOOTER //
// ./pages/guest/helper.js